module.exports = __webpack_public_path__ + "img/Koketterie.3c721bee.jpg";